export enum TriggerType {
  ATTRIBUTE = 'ATTRIBUTE',
  DATETIME = 'DATETIME'
}
